module.exports = __webpack_public_path__ + "0a87836ac5f42f232e2ab0a28e3bcaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/goldencity.jpg
// module id = 629
// module chunks = 0